import styled from "styled-components";
import { Tabs } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";

export const STTabs = styled(Tabs).attrs({
  classes: {
    indicator: "indicator",
  },
})`
  && {
    .indicator {
      background-color: ${blue[500]};
    }
  }
`;
